// Change this one object to update every date/time on the site
export const SESSION = {
  dayLabel: "Thursday",
  dateLabel: "Thursday, 22nd October 2026",
  shortLabel: "Thursday, 22 Oct",
  timeLabel: "8:00 PM – 10:00 PM IST",
  startTime: "8:00 PM",
  startISO: "2026-10-22T20:00:00+05:30",
  endISO: "2026-10-22T22:00:00+05:30",
  calendarDates: "20261022T143000Z/20261022T163000Z",
};
